import PropTypes from 'prop-types'
import React from 'react'

import { GOODS_TYPES } from 'constants/sales'
import AddAndGoToCart from 'containers/AddAndGoToCart'
import { Col, Row } from 'styles/components/layout'
import { Text } from 'styles/components/typography'

import {
  BoxBaseStyled,
  H1SmallStyled,
  DynamicImageStyled,
  Wrapper,
  CostContainerSaleStyled,
  CostWrapper,
} from './styles'

const DAboutOrderTest = ({ data, path }) => {
  return (
    <BoxBaseStyled>
      <Row alignItems={{ lg: 'center' }}>
        <Col width={{ xs: 1, md: 3 / 6, lg: 5 / 12 }}>
          <H1SmallStyled dangerouslySetInnerHTML={{ __html: data.title }} />
          <Text dangerouslySetInnerHTML={{ __html: data.subtitle }} />
        </Col>
        <Col width={{ xs: 1, md: 3 / 6, lg: 4 / 12 }}>
          <Wrapper>
            <DynamicImageStyled
              image={`${path}/dna-left-new`}
              imageType="png"
              imageSizes={{ xs: 223, md: 400, lg: 336 }}
              fitOption="contain"
              alt={'Генетический тест'}
            />
          </Wrapper>
        </Col>
        <Col width={{ xs: 1, lg: 3 / 12 }}>
          <CostWrapper>
            <CostContainerSaleStyled
              productType={GOODS_TYPES.dna}
              isWhite={true}
              isTabNotCenter={true}
            />

            <AddAndGoToCart
              goods={[
                {
                  type: GOODS_TYPES.dna,
                  isSubscription: false,
                },
              ]}
              buttonProps={{
                bgClassName: 'bg--green',
                withTopMarginOnMobile: true,
              }}
              forceMultipleAdd={true}
              buttonTitleKey="buy"
            />
          </CostWrapper>
        </Col>
      </Row>
    </BoxBaseStyled>
  )
}

DAboutOrderTest.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  }),
  path: PropTypes.string.isRequired,
}

export default React.memo(DAboutOrderTest)
